export default __webpack_public_path__ + "static/media/akiva_pshutim.22fe8427.mp3";